// The status control, top right.
//
// Three states, always visible, one click each. Not a dropdown: which one you
// are is worth being able to read without opening anything, and setting it
// should not cost two clicks mid-call.

import { STATUS_LABELS, type PresenceApi, type Status } from '../presence/usePresence';

const ORDER: Status[] = ['available', 'busy', 'away'];

export function StatusPicker({ presence }: { presence: PresenceApi }) {
  return (
    <div
      className="status"
      role="group"
      aria-label="Your status"
      // The status is on screen either way; the failure is worth knowing about
      // without being worth a banner.
      title={presence.problem ?? undefined}
    >
      {ORDER.map((status) => {
        const on = presence.status === status;
        return (
          <button
            key={status}
            type="button"
            className={`status__opt status__opt--${status}${on ? ' status__opt--on' : ''}`}
            aria-pressed={on}
            onClick={() => presence.setStatus(status)}
          >
            <span className="status__dot" />
            {STATUS_LABELS[status]}
          </button>
        );
      })}
      {/* Says why it went busy on its own, so the change does not look like a
          glitch or like somebody else setting it. */}
      {presence.status === 'busy' && presence.source === 'call' && (
        <span className="status__why">on a call</span>
      )}
      {presence.problem && <span className="status__warn" aria-hidden="true">!</span>}
    </div>
  );
}
